
import { Icon, Modal, Button } from '@descomplica/vue-components';
import Vue from 'vue';
import { Route } from 'vue-router';
import { ShowCaseHelper } from '@/helpers/trial';

interface Topic {
  name: string;
  icon: string;
  description: string;
}

interface Data {
  isActive: Boolean;
  width: number;
}

export default Vue.extend({
  components: {
    Icon,
    Modal,
    Button,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      isActive: this.active,
      width: window.innerWidth,
    };
  },
  computed: {
    getTopics(): Topic[] {
      return this.$t('trial.showCase.modals.selectiveProcess.topics') as any as Topic[];
    },
  },
  watch: {
    $route(to) {
      (this as any).showCaseOpenSelectiveModal(to);
    },
  },
  mounted() {
    window.addEventListener('resize', this.setDimensions);
    (this as any).showCaseOpenSelectiveModal(this.$router.currentRoute);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setDimensions);
  },
  methods: {
    showcaseHasFinished(): boolean {
      return ShowCaseHelper.showCaseHasFinished();
    },
    onCloseClick() {
      this.$data.isActive = false;
    },
    onClickSelectiveProcessButton(): void {
      window.open(this.$t('trial.showCase.modals.selectiveProcess.selectiveProcessUrl') as string);
    },
    onClickSurprise(): void {
      this.$data.isActive = false;
      this.$router.push({
        query: { openCoupon: 'open' },
      });
    },
    setDimensions(): void {
      this.width = window.innerWidth;
    },
    showCaseOpenSelectiveModal(to: Route): void {
      if (to?.query?.openSelectiveProcess === 'open') {
        this.$data.isActive = true;

        const query = { ...this.$route.query };
        delete query.openSelectiveProcess;
        this.$router.replace({ query });
      }
    },
    getDevice(): string {
      let device = 'desktop';
      if (this.width < 768) {
        device = 'mobile';
      }
      if (this.width >= 768 && this.width < 1287) {
        device = 'tablet';
      }

      return device;
    },
    getImgByDevice(): string {
      return `${
        process.env.BASE_URL || ''
      }img/trial/showcase/modals/selective-process-${this.getDevice()}.svg`;
    },
  },
});
